import { Container } from "react-bootstrap";

export default props => {
  return (
    <Container fluid className={props.pageStyle}>
      {props.children}
    </Container>
  );
};
